import { MembershipsCreatorV2ApiClient } from '@fourthwall/services/dist/MembershipsCreatorV2ApiClient'
import { createQueryHook } from '@fourthwall/utils/dist/queries'

export const useSingleSeriesQuery = createQueryHook(MembershipsCreatorV2ApiClient.getSingleSeries, {
  queryKey: ['singleSeries'],
})
